module.exports = __webpack_public_path__ + "img/xbc01.22352b31.png";